import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import {
  GET_PRODUCTS_LIST,
  GET_PRODUCT,
  GET_KNOWLEDGE_CENTER,
  ADD_TO_CART,
  CHECKOUT_ORDER,
  GET_SITES_LIST,
} from "./type";

export const getProducts = (page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.products.fetchProductsList}?page=${page}`
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: GET_PRODUCTS_LIST, payload: res.data.response.data });
    return data;
  } else {
    return null;
  }
};

export const getProductDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.products.fetchProduct}?product_id=${id}`
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: GET_PRODUCT, payload: data?.response?.data });
    return data;
  } else {
    return null;
  }
};

export const getDocsList = (page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.knowledgeCenter.fetchKnowledgeCenter}?page=${page}`
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: GET_KNOWLEDGE_CENTER, payload: data?.response?.data });
    return data;
  } else {
    return null;
  }
};

export const addInCart = (cartList) => async (dispatch) => {
  cartList !== null &&
    localStorage.setItem("cartList", JSON.stringify(cartList));

  const cartData =
    (await JSON.parse(localStorage.getItem("cartList"))) &&
    JSON.parse(localStorage.getItem("cartList"));

  dispatch({ type: ADD_TO_CART, payload: cartData });
  return true;
};

export const checkoutOrder = (request) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    request,
    Config.products.checkoutOrder
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: CHECKOUT_ORDER, payload: data?.response?.data });
    return data?.response;
  } else {
    return false;
  }
};

export const getSitesList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.products.sitesList
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: GET_SITES_LIST, payload: data?.response?.data });
    return data;
  } else {
    return null;
  }
};
